import { snackbarService } from '/common/snackbarService';
import { clipboardWrite } from '/helpers';

export const handleCopyClick = () => {
  clipboardWrite(window.location.href);
  snackbarService.success('Link copied to clipboard');
};

/**
 * Copies a deep-link to the clipboard for a given entity.
 *
 * @template E - The entity type, which must contain at least `app` and `id` fields.
 * @param {E} entity - The entity object containing `app` (application name) and `id` (unique identifier).
 */

export const handleCopyItemClick = <E extends { app: string; id: string }>(entity: E) => {
  clipboardWrite(`${window.location.href}/${entity.app}/${entity.id}`);

  snackbarService.success('Link copied to clipboard');
};
